import { useEffect, useState } from "react";

// Date the site went live, in YYYY-MM-DD format.
// Fading begins the day AFTER this date — update this before each real deploy.
export const DEPLOY_DATE = "2026-08-04";

const MS_PER_DAY = 24 * 60 * 60 * 1000;
const FADE_STEP_PERCENT = 20; // opacity drops by this much per day: 20, 40, 60, 80, 100

const startOfDay = (date) => {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  return d;
};

// Pure function so it's easy to unit-test / reason about independent of React.
export const getFadeOpacity = (deployDate = DEPLOY_DATE) => {
  const deployed = startOfDay(deployDate);
  const today = startOfDay(new Date());
  const daysSinceDeploy = Math.floor((today - deployed) / MS_PER_DAY);

  if (daysSinceDeploy <= 0) return 1; // deploy day: fully visible

  const fadePercent = Math.min(daysSinceDeploy * FADE_STEP_PERCENT, 100);
  return 1 - fadePercent / 100;
};

// Recomputes hourly so a tab left open overnight still updates without a manual refresh.
const useContentFade = (deployDate = DEPLOY_DATE) => {
  const [opacity, setOpacity] = useState(() => getFadeOpacity(deployDate));

  useEffect(() => {
    const id = setInterval(() => {
      setOpacity(getFadeOpacity(deployDate));
    }, 60 * 60 * 1000);
    return () => clearInterval(id);
  }, [deployDate]);

  return opacity;
};

export default useContentFade;
